import { TCloseConnection, TCreateConnection } from './models'
import API from '../api';

const PATH_CONNECTION = '/Connections';

const createConnection = () => API.post<TCreateConnection>(`${PATH_CONNECTION}/create`);

const closeConnection = (value: TCloseConnection) => API.post<any>(`${PATH_CONNECTION}/close`, value);

export { createConnection, closeConnection };